(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-gallery-pdp"] && !Shopify.designMode) return;
  try {
    
/********************************************************************
 Video Gallery JS
 ↳ “Clicking” a little preview simply opens the modal with the full video.
********************************************************************/
document.addEventListener("DOMContentLoaded", function() {
  var thumbs       = document.querySelectorAll(".mvk-video-thumb-wrapper");
  var modal        = document.getElementById("video-gallery-modal");
  var player       = document.getElementById("video-gallery-player");
  var source       = document.getElementById("video-gallery-source");
  var closeButtons = modal.querySelectorAll("[data-close-modal]");

  thumbs.forEach((thumb, i) => {

    thumb.addEventListener('click', () => {
      const videoSrc = thumb.getAttribute('data-video-src');
      if (!videoSrc) {
        return;
      }

      source.src = videoSrc;
      player.load();
      player.play();
      modal.classList.remove('hidden');
    });
  });

  closeButtons.forEach(function(btn) {
    btn.addEventListener("click", function() {
      player.pause();
      source.setAttribute("src", "");
      player.load();
      modal.classList.add("hidden");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
